module.exports = __webpack_public_path__ + "static/media/logo_reliant.3cc0d5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/business_group_logos/logo_reliant.jpg
// module id = 777
// module chunks = 0